import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://ns-dashboard-api.kabilah.com';

const AacnContext = createContext();

export const AacnProvider = ({ children }) => {
  const [subCompetencies, setSubCompetencies] = useState([]);
  const [indicatorDomains, setIndicatorDomains] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAacn = useCallback(() => {
    setLoading(true);
    axios.get(`${BACKEND_URL}/api/aacn/sub-competencies`)
      .then((res) => {
        if (Array.isArray(res.data?.subCompetencies)) setSubCompetencies(res.data.subCompetencies);
        if (Array.isArray(res.data?.indicatorDomains)) setIndicatorDomains(res.data.indicatorDomains);
      })
      .catch(() => {
        setSubCompetencies([]);
        setIndicatorDomains([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchAacn();
  }, [fetchAacn]);

  const getSubCompetencyByCode = (code) => subCompetencies.find((sc) => sc.subCompetencyCode === code);

  return (
    <AacnContext.Provider value={{ subCompetencies, indicatorDomains, loading, getSubCompetencyByCode, fetchAacn }}>
      {children}
    </AacnContext.Provider>
  );
};

export default AacnContext;
